import {
  Code24Regular,
  Document24Regular,
  DocumentPdf24Regular,
  DocumentText24Regular,
  SlideText24Regular,
} from '@/components/Icon'
import { useDocumentPreviewOptional } from '@/features/documentPreview/useDocumentPreview'
import { useArtifactDocument } from '@/features/chat/documents/useArtifactDocument'
import ContextCard from '@/components/ContextCard/ContextCard'
import { artifactCardStatus, artifactDocumentId } from './artifactCardStatus'
import ArtifactCardInner from './ArtifactCardInner'
import { artifactContextTitle, cleanTitle, kindLabel } from './artifactCardHelpers'
import { useArtifactCardPreview } from './useArtifactCardPreview.js'

const KIND_ICON = {
  pdf: DocumentPdf24Regular,
  pptx: SlideText24Regular,
  html: Code24Regular,
  markdown: DocumentText24Regular,
  other: Document24Regular,
}

export default function ArtifactCardBlock({ block }) {
  const preview = useDocumentPreviewOptional()
  const title = cleanTitle(block.title)
  const documentId = artifactDocumentId(block)
  const document = useArtifactDocument(documentId)
  const status = artifactCardStatus(documentId, document.data)
  const hasPreviewUrl = Boolean(block.preview_url)
  const hasDocumentId = Boolean(documentId)
  const canPreview = Boolean(preview && (hasPreviewUrl || hasDocumentId))
  const handlePreview = useArtifactCardPreview(block, {
    canPreview,
    preview,
    title,
    documentId,
  })
  const showPreviewButton = hasPreviewUrl || hasDocumentId
  return (
    <ContextCard activity="artifact" title={artifactContextTitle(block.kind)} plain>
      <ArtifactCardInner
        Icon={KIND_ICON[block.kind] ?? KIND_ICON.other}
        title={title}
        status={status}
        kindText={kindLabel(block.kind, block.size_label)}
        canPreview={canPreview}
        onPreview={showPreviewButton ? handlePreview : null}
      />
    </ContextCard>
  )
}
